module.exports = __webpack_public_path__ + "img/IQ.bcc9d10f.svg";